import { legacy_connect as connect } from 'react-redux';

import { TabbedDatasetLayoutViewModel } from '../../../../services/category/view-model/DatasetLayoutViewModel';
import UniqueId from '../../../../services/uid/UniqueId';
import { AppState } from '../../../../store/reducers/root';
import { getCategoryLayoutActiveTab } from '../../../../store/selectors/category';
import categoryActions from '../../../../store/slices/category';

import CategoryTabs from './CategoryTabs';

interface Props {
  categoryId: UniqueId;
  element: TabbedDatasetLayoutViewModel;
}

const mapStateToProps = (state: AppState, ownProps: Props) => ({
  activeTab: getCategoryLayoutActiveTab(
    state,
    ownProps.categoryId,
    ownProps.element.id
  ),
});

const mapDispatchToProps = {
  onActivateTab: categoryActions.activateLayoutTab,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  { onActivateTab }: typeof mapDispatchToProps,
  { categoryId, element, ...oP }: Props
) => ({
  ...sP,
  ...oP,
  categoryId,
  element,
  onActivateTab: (tabPaneElementId: UniqueId) =>
    onActivateTab({
      categoryId,
      tabsElementId: element.id,
      tabPaneElementId,
    }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default connector(CategoryTabs);
